import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import MiniSlideshowGeneric from "../MiniSlideshow/MiniSlideshowGeneric";
import { AppContextConsumer } from "../AppContext/AppContext";
import Popup from "../Popup/Popup";
import ReactDOM from "react-dom";
import Modal from "../Modal/Modal";
import RateDetailsPop from "../Rate/RateDetailsPop";
import ProductForm from "../Forms/ProductForm";

class SingleExtraCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      details: false,
      productDetails:false,
      upsellsOrder:[]

    };
  }

  handleProductDetails=(data,context)=>{
    // console.log(data);
    this.setState(prevState=>{
      // console.log(context);
      return {details:<Popup 
              title={data.name}
              data={data}
              context={context}
              handleKillPopup={this.handleKillPopup} 
              handleSingleExtra={this.props.handleSingleExtra}
            />}
    });
  }

  handleKillPopup=()=>{
    this.setState(prevState=>{
      return {details:false}
    });
  }

  shortenText = (text, maxLength) => {
    if (text.length <= maxLength) return text;

    let trimmedText = text.slice(0, maxLength);
    let lastSpaceIndex = trimmedText.lastIndexOf(" ");

    if (lastSpaceIndex > 0) {
      trimmedText = trimmedText.slice(0, lastSpaceIndex);
    }

    return trimmedText + "...";
  };

  handleKillDetails = () => {
    this.setState({ details: false });
  };

  render() {
    const { product, handleSingleExtra,upsellsOrder } = this.props;
    console.log(handleSingleExtra,product);
    const testp = {
    form: product.form,
    priceFormula: product.priceFormula,
    basePrice: product.basePrice
  };
   console.log(product.id,upsellsOrder);
   let existsInOrder = false;
   Object.values(upsellsOrder).forEach(element => {
    if(element.id === product.id){
      existsInOrder = JSON.parse(JSON.stringify(element));
    }
   });

    const url =
      `/guest-portal/product/` +
      product.name.replaceAll(" ", "-") +
      "/" +
      product.id;


      return (
        <AppContextConsumer>
        {(context) => {
          console.log(context);
          let data = { product: product };
          return (
            
            <div id="room" className="single-extra-card">
              
              {this.state.details}
              {!!existsInOrder ?
                <div className="ribbon">
                  <span>In Cart</span>
                </div>
              :""}
              <MiniSlideshowGeneric feat={product.feat} gallery={product.gallery} />
              <div className="extra-content">
                <h4 >
                  {product.name}
                </h4>
                {/* <p>{this.shortenText(product.description, 250)}</p> */}

                <div>
                  
                  <div className='flex flex-y-center flex-walls'>
                        {product.form && product.form.length>0 ?
                          <ProductForm 
                            product={product} 
                            handleSingleExtra={this.props.handleSingleExtra} 
                            existsInOrder={existsInOrder}
                          />
                        :""}
                    </div>
                  <div>
                    
                    <div
                      className="link"
                      onClick={() => {
                        this.handleProductDetails(product, context);
                      }}
                    >
                      See details
                    </div>
                    <div className="spec head-spec">
                </div>
                  </div>
                </div>
              </div>
            </div>
          );
        }}
      </AppContextConsumer>
    );
  }
}

export default SingleExtraCard;
